<template>
  <div>
    <v-navigation-drawer
      clipped
      app
      v-model="drawerValue"
      :width="drawerWidth"
      :disable-resize-watcher="true"
      class="sidedrawer"
      permanent
      id="filter-menu"
    >
      <v-container grid-list-xs text-xs-center pa-0>
        <v-layout column class="flex">
          <v-flex xs12>
            <v-toolbar flat class="white">
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content class="title">
                    <v-tooltip bottom>
                      <div slot="activator">
                        <v-toolbar
                          app
                          clipped-left
                          flat
                          color="white"
                        >
                        Filter by
                        </v-toolbar>
                      </div>
                      {{updateFilters != null ? 'Apply new filter settings...' : 'Data is up-to-date with filter settings.'}}
                    </v-tooltip>
                  </v-list-tile-content>
                </v-list-tile>
                <!-- <v-subheader inset>
                  <v-progress-linear :value="100" :indeterminate="updateFilters != null" color="shades black" height="1"></v-progress-linear>
                </v-subheader> -->
              </v-list>
            </v-toolbar>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12>
            <v-layout row>
              <v-flex>
                <div
                  :style="'width: ' + firstFilterColWidth + 'px;'"
                >
                  <v-list three-line class="py-3">
                    <v-list-tile @click="openLocationFilter()" :class="locationFilterClass">
                    <v-badge color="primary">
                      <v-list-tile-content>
                        <v-container text-xs-center class="pa-1">
                            <v-layout column>
                              <v-flex>
                                <v-icon>
                                  explore
                                </v-icon>
                              </v-flex>
                              <v-flex>
                                Countries and Regions
                              </v-flex>
                            </v-layout>
                          </v-container>
                       </v-list-tile-content>
                       <span slot="badge" v-if="isSelectedDimensionOrComplement(constants.REGION_DIMENSION)">
                       {{$store.getters.getDimensionItems(constants.REGION_DIMENSION, true).length}}
                       </span>
                       <span slot="badge" v-else>
                       {{$store.getters.getDimensionItems(constants.COUNTRY_DIMENSION, true).length}}
                       </span>
                       </v-badge>
                     </v-list-tile>
                     <v-list-tile @click="openTopicFilter()" :class="topicFilterClass">
                     <v-badge color="primary">
                      <v-list-tile-content>
                        <v-container text-xs-center class="pa-1">
                            <v-layout column>
                              <v-flex>
                                <v-icon>
                                  class
                                </v-icon>
                              </v-flex>
                              <v-flex>
                                Classes and Subclasses
                              </v-flex>
                            </v-layout>
                          </v-container>
                       </v-list-tile-content>
                       <span slot="badge" v-if="isSelectedDimensionOrComplement(constants.SUBCLASS_DIMENSION)">
                       {{$store.getters.getDimensionItems(constants.SUBCLASS_DIMENSION, true).length}}
                       </span>
                       <span slot="badge" v-else>
                       {{$store.getters.getDimensionItems(constants.CLASS_DIMENSION, true).length}}
                       </span>
                       </v-badge>
                     </v-list-tile>
                  </v-list>
                </div>
              </v-flex>

          <v-flex :class="flexClass" v-if="filterDimension === 'topic'">
            <v-list>
              <v-list-tile>
                <v-list-tile-title>
                  Classes
                </v-list-tile-title>
                <v-list-tile-action>
                  <v-btn icon @click="closeTopicFilter()">
                    <v-icon>
                      close
                    </v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile @click="toggleAllTopics()" :class="selectedItemClass(null)">
                <v-list-tile-action>
                  <v-checkbox :input-value="someTopicsSelected"
                    :indeterminate="allTopicsIndeterminate" @click.stop="toggleAllTopics()"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  indicator totals
                </v-list-tile-content>
                <v-list-tile-action
                v-if="isSelectedDimensionOrComplement(constants.SUBCLASS_DIMENSION)">
                  <v-btn icon @click.stop="selectDetailTopic(null)">
                    <v-icon small>arrow_forward_ios</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              </v-list>
              <v-list dense>
              <!-- TODO: implement this, a mere copy of the country filter for now-->
              <v-list-tile style="height: 50px;">
                <v-list-tile-content style="height: 50px;">
                  <v-text-field append-icon="search" v-model="topicFilter" clearable>
                  default slot
                  </v-text-field>
                </v-list-tile-content>
              </v-list-tile>
              <v-subheader v-if="topicFilter !== null && topicFilter !== '' && filteredTopics.length !== 0">{{filteredTopics.length}} matching classes found</v-subheader>
              <v-subheader v-if="topicFilter !== null && topicFilter !== '' && filteredTopics.length === 0">No matching classes found</v-subheader>
            </v-list>

              <template v-for="rootTopic in constants.ROOT_TOPICS">
                <v-list :key="rootTopic.code + '_head'">
                  <v-list-tile @click="toggleRootTopic(rootTopic)">
                    <v-list-tile-action>
                      <v-checkbox :input-value="someTopicsOfRootTopicSelected(rootTopic)"
                        @click.stop="toggleRootTopic(rootTopic)"
                        :indeterminate="allTopicsOfRootTopicIndeterminate(rootTopic)"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-title>
                      {{ rootTopic.text.charAt(0).toUpperCase() + rootTopic.text.slice(1) }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>

                <v-list dense :key="rootTopic.code + '_body'">
                <div v-for="topic in filteredTopics.filter(t => t.parent === rootTopic.code)" :key="topic.code + topic.parent">
                  <v-list-tile @click="toggleTopic(topic, !topic.selected, true)" :class="selectedItemClass(topic)">
                    <v-list-tile-action>
                      <v-checkbox v-model="topic.selected"
                                  @click.stop="toggleTopic(topic, !topic.selected, true)"
                                  :indeterminate="isSelectedDimensionOrComplement(constants.SUBCLASS_DIMENSION) && subtopics.some(t => t.parent === topic.code && t.selected)  && subtopics.some(t => t.parent === topic.code && !t.selected)"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ topic.text.charAt(0).toUpperCase() + topic.text.slice(1) }}
                    </v-list-tile-content>
                    <v-list-tile-action
                      v-if="isSelectedDimensionOrComplement(constants.SUBCLASS_DIMENSION)"
                      @click.stop="selectDetailTopic(topic)"
                    >
                      <v-btn icon>
                        <v-icon small>arrow_forward_ios</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-tooltip right v-model="topic.tooltip" :disabled="isSelectedDimensionOrComplement(constants.SUBCLASS_DIMENSION)">
                    <span slot="activator"></span>
                    <span>Switch to "Explore ... by <strong>SUBCLASS</strong>", respectively <br> "Show <strong>SUBCLASS</strong> ..." to browse the subclasses.</span>
                  </v-tooltip>
                </div>
                </v-list>
                <v-divider :key="rootTopic.code + '_foot'"></v-divider>
              </template>
          </v-flex>

          <v-flex :class="flexClass" v-if="filterDimension === 'location'"> <!-- TODO: reset the detailCountry -->
            <v-list>
              <v-list-tile>
                <v-list-tile-title>
                  Countries
                </v-list-tile-title>
                <v-list-tile-action>
                  <v-btn icon @click="closeLocationFilter()">
                    <v-icon>
                      close
                    </v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile @click="toggleAllCountries()" :class="selectedItemClass(null)">
                <v-list-tile-action>
                  <v-checkbox :input-value="someCountriesSelected" :indeterminate="allCountriesIndeterminate" @click.stop="toggleAllCountries()"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  all countries
                </v-list-tile-content>
                <v-list-tile-action
                v-if="isSelectedDimensionOrComplement(constants.REGION_DIMENSION)">
                  <v-btn icon @click.stop="selectDetailCountry(null)">
                    <v-icon small>arrow_forward_ios</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>

            <v-list dense>
              <v-list-tile style="height: 50px;">
                <v-list-tile-content style="height: 50px;">
                  <v-text-field append-icon="search" v-model="countryFilter" clearable>
                  default slot
                  </v-text-field>
                </v-list-tile-content>
              </v-list-tile>
              <v-subheader v-if="countryFilter !== null && countryFilter !== '' && filteredCountries.length !== 0">{{filteredCountries.length}} matching countries found</v-subheader>
              <v-subheader v-if="countryFilter !== null && countryFilter !== '' && filteredCountries.length === 0">No matching countries found</v-subheader>
              <div v-for="country in filteredCountries" :key="country.code">
                <v-list-tile @click="toggleCountry(country, true)" :class="selectedItemClass(country)">
                  <v-list-tile-action>
                    <v-checkbox v-model="country.selected"
                      @click.stop="toggleCountry(country, false)"
                                :indeterminate="isSelectedDimensionOrComplement(constants.REGION_DIMENSION) && allRegions.some(r => r.country === country.code && r.selected) && allRegions.some(r => r.country === country.code && !r.selected)">
                    </v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ country.text }}
                  </v-list-tile-content>
                  <v-list-tile-action
                    v-if="isSelectedDimensionOrComplement(constants.REGION_DIMENSION)"
                    @click.stop="selectDetailCountry(country)">
                    <v-btn icon>
                      <v-icon small>
                        arrow_forward_ios
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-tooltip right v-model="country.tooltip" :disabled="isSelectedDimensionOrComplement(constants.REGION_DIMENSION)">
                  <span slot="activator"></span>
                  <span>Switch to "Explore ... by <strong>REGION</strong>", respectively <br> "Show <strong>REGION</strong> ..." to browse the regions.</span>
                </v-tooltip>
              </div>
            </v-list>
          </v-flex>

          <v-flex :class="flexClass" v-if="filterDimension === 'topic' && isSelectedDimensionOrComplement(constants.SUBCLASS_DIMENSION)"> <!-- TODO -->
            <v-list>
              <v-list-tile>
                <v-list-tile-title v-if="detailTopic !== null">
                  Subclasses of {{detailTopic.text}}
                </v-list-tile-title>
                <v-list-tile-title v-else>
                  Subclasses of all classes
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="toggleAllSubtopics()">
                <v-list-tile-action>
                  <v-checkbox :input-value="someSubtopicsSelected" @click.stop="toggleAllSubtopics()"
                    :indeterminate="allSubtopicsIndeterminate"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  all subclasses
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list dense>
              <v-list-tile style="height: 50px;">
                <v-list-tile-content style="height: 50px;">
                  <v-text-field append-icon="search" v-model="subtopicFilter" clearable>
                  default slot
                  </v-text-field>
                </v-list-tile-content>
              </v-list-tile>
              <!-- TODO implement this! -->
              <v-subheader v-if="subtopicFilter !== null && subtopicFilter !== '' && filteredSubtopics.length !== 0">{{filteredSubtopics.length}} matching subclasses found</v-subheader>
              <v-subheader v-if="subtopicFilter !== null && subtopicFilter !== '' && filteredSubtopics.length === 0">No matching subclasses found</v-subheader>
              <v-list-tile @click="toggleSubtopic(subtopic, !subtopic.selected, true)" v-for="subtopic in filteredSubtopics" :key="subtopic.code + '_' + subtopic.parent">
                <v-list-tile-action>
                  <v-checkbox v-model="subtopic.selected" @click.stop="toggleSubtopic(subtopic, !subtopic.selected, false)"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{subtopic.text}}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>

          <v-flex :class="flexClass" v-if="filterDimension === 'location' && isSelectedDimensionOrComplement(constants.REGION_DIMENSION)">
            <v-list>
              <v-list-tile>
                <v-list-tile-title v-if="detailCountry !== null">
                  Regions of {{detailCountry.text}}
                </v-list-tile-title>
                <v-list-tile-title v-else>
                  Regions of all countries
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="toggleAllRegions()">
                <v-list-tile-action>
                  <v-checkbox :input-value="someRegionsSelected" @click.stop="toggleAllRegions()"
                    :indeterminate="allRegionsIndeterminate"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  all regions
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list dense>
              <v-list-tile style="height: 50px;">
                <v-list-tile-content style="height: 50px;">
                  <v-text-field append-icon="search" v-model="regionFilter" clearable>
                  default slot
                  </v-text-field>
                </v-list-tile-content>
              </v-list-tile>
              <v-subheader v-if="regionFilter !== null && regionFilter !== '' && filteredRegions.length !== 0">{{filteredRegions.length}} matching regions found</v-subheader>
              <v-subheader v-if="regionFilter !== null && regionFilter !== '' && filteredRegions.length === 0">No matching regions found</v-subheader>
              <v-list-tile @click="toggleRegion(region)" v-for="region in filteredRegions" :key="region.code">
                <v-list-tile-action>
                  <v-checkbox v-model="region.selected" @click.stop="toggleRegion(region)"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{region.text}}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
            </v-layout>
            <v-divider></v-divider>
          </v-flex>

        </v-layout>
      </v-container>
      <v-spacer>
      </v-spacer>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import constants from '../constants.js'

export default {
  name: 'sidedrawer',
  props: {
    drawer: Boolean,
    selectedDimension: Object,
    selectedComplement: Object,
    filterDimension: String
  },
  data () {
    return {
      snackbar: false,
      topicSnackbar: false,
      detailCountry: null,
      detailTopic: null,
      firstFilterColWidth: 150,
      furtherFilterColWidth: 330,
      countryFilter: '',
      regionFilter: '',
      topicFilter: '',
      subtopicFilter: ''
    }
  },
  mounted () {
    this.$root.$on('Sidedrawer', () => {
      this.closeTopicFilter()
    })
  },
  computed: {
    ...mapState(['countries', 'regions', 'topics', 'subtopics']),
    constants: {
      get () {
        return constants
      }
    },
    updateFilters: {
      get () {
        return this.$store.state.updateFiltersTimestamp
      },
      set (timestamp) {
        this.$store.dispatch('updateFilters', timestamp)
      }
    },
    drawerValue: {
      get () {
        return this.drawer
      },
      set (drawer) {
        this.$emit('update:drawer:value', drawer)
      }
    },
    rootTopicCodes () {
      return this.constants.ROOT_TOPICS.map(t => t.code)
    },
    detailSubtopics () {
      if (this.detailTopic === null) {
        return this.subtopics
      }
      return this.subtopics.filter(t => t.parent === this.detailTopic.code)
    },
    filteredRegions () {
      if (this.regionFilter === null || this.regionFilter === '') {
        return this.regions
      }
      return this.regions.filter(r => r.text.toLowerCase().includes(this.regionFilter.toLowerCase()))
    },
    filteredSubtopics () {
      if (this.subtopicFilter === null || this.subtopicFilter === '') {
        return this.detailSubtopics
      }
      return this.detailSubtopics.filter(t => t.text.toLowerCase().includes(this.subtopicFilter.toLowerCase()))
    },
    filteredTopics () {
      if (this.topicFilter === null || this.topicFilter === '') {
        return this.topics
      }
      return this.topics.filter(t => t.text.toLowerCase().includes(this.topicFilter.toLowerCase()))
    },
    regions () {
      let regions = this.$store.state.regions
      if (this.detailCountry !== null) {
        regions = regions.filter(r => r.country === this.detailCountry.code)
      }
      return regions.sort((a, b) => a.text.localeCompare(b.text))
    },
    allRegions () {
      return this.$store.state.regions
    },
    filteredCountries () {
      if (this.countryFilter === null || this.countryFilter === '') {
        return this.countries
      }
      return this.countries.filter(c => c.text.toLowerCase().includes(this.countryFilter.toLowerCase()))
    },
    allCountriesSelected () {
      return this.countries.every(c => c.selected)
    },
    someCountriesSelected () {
      return this.countries.some(c => c.selected)
    },
    allCountriesIndeterminate () {
      return this.countries.some(c => c.selected) && this.countries.some(c => !c.selected)
    },
    someRegionsSelected () {
      if (this.detailCountry === null) {
        return this.$store.state.regions.some(r => r.selected)
      }
      return this.$store.state.regions.some(r => r.country === this.detailCountry.code && r.selected)
    },
    allRegionsIndeterminate () {
      if (this.detailCountry === null) {
        return this.$store.state.regions.some(r => r.selected) && this.$store.state.regions.some(r => !r.selected)
      }
      return this.$store.state.regions.some(r => r.country === this.detailCountry.code && r.selected) && this.$store.state.regions.some(r => r.country === this.detailCountry.code && !r.selected)
    },
    someTopicsSelected () {
      return this.topics.some(c => c.selected)
    },
    allTopicsIndeterminate () {
      return this.topics.some(t => t.selected) && this.topics.some(t => !t.selected)
    },
    allSubtopicsIndeterminate () {
      if (this.detailTopic === null) {
        return this.subtopics.some(t => t.selected) && this.subtopics.some(t => !t.selected)
      }
      return this.subtopics.some(t => t.parent === this.detailTopic.code && t.selected) && this.subtopics.some(t => t.parent === this.detailTopic.code && !t.selected)
    },
    someSubtopicsSelected () {
      if (this.detailTopic === null) {
        return this.subtopics.some(t => t.selected)
      } else {
        return this.subtopics.filter(t => t.parent === this.detailTopic.code).some(t => t.selected)
      }
    },
    drawerWidth () {
      let width = this.firstFilterColWidth + 15
      if (this.filterDimension === 'location') {
        if (this.isSelectedDimensionOrComplement(constants.COUNTRY_DIMENSION)) {
          width = this.firstFilterColWidth + this.furtherFilterColWidth
        } else {
          width = this.firstFilterColWidth + this.furtherFilterColWidth * 2
        }
      } else if (this.filterDimension === 'topic') {
        if (this.isSelectedDimensionOrComplement(constants.CLASS_DIMENSION)) {
          width = this.firstFilterColWidth + this.furtherFilterColWidth
        } else {
          width = this.firstFilterColWidth + this.furtherFilterColWidth * 2
        }
      }
      this.$emit('update:drawer:width', this.drawer * width)
      return width
    },
    flexClass () {
      let flexClass = 'xs6'
      if (this.filterDimension === null) {
        flexClass = 'xs12'
      } else {
        flexClass = 'xs5'
        if (this.filterDimension === 'location') {
          if (this.isSelectedDimensionOrComplement(constants.COUNTRY_DIMENSION)) {
            flexClass = 'xs8'
          }
        }
        if (this.filterDimension === 'topic') {
          if (this.detailTopic === null || this.isSelectedDimensionOrComplement(constants.CLASS_DIMENSION)) {
            flexClass = 'xs8'
          }
        }
      }
      return flexClass
    },
    topicFilterClass () {
      let result = 'py-1 px-2'
      if (this.filterDimension === this.constants.CLASS_DIMENSION.dimensionType) {
        result += ' selectedFilterDimension'
      }

      return result
    },
    locationFilterClass () {
      let result = 'py-1 px-2'
      if (this.filterDimension === this.constants.COUNTRY_DIMENSION.dimensionType) {
        result += ' selectedFilterDimension'
      }

      return result
    }
  },
  methods: {
    someTopicsOfRootTopicSelected (rootTopic) {
      return this.topics.filter(t => t.parent === rootTopic.code).some(c => c.selected)
    },
    allTopicsOfRootTopicIndeterminate (rootTopic) {
      return this.topics.filter(t => t.parent === rootTopic.code).some(t => t.selected) && this.topics.filter(t => t.parent === rootTopic.code).some(t => !t.selected)
    },
    selectedItemClass (item) {
      let result = ''
      if ((this.isSelectedDimensionOrComplement(constants.SUBCLASS_DIMENSION) && item === this.detailTopic) ||
        (this.isSelectedDimensionOrComplement(constants.REGION_DIMENSION) && item === this.detailCountry)) {
        result += 'selectedFilterDimension'
      }

      return result
    },
    isSelectedDimensionOrComplement (dimension) {
      return this.selectedDimension === dimension || this.selectedComplement === dimension
    },
    toggleAllCountries () {
      let newValue = !this.someCountriesSelected
      this.countries.forEach(function (c) {
        c.selected = newValue
      }, this)
      this.$store.state.regions.forEach(function (r) {
        r.selected = newValue
      }, this)

      this.updateFiltersNow(true, this.constants.COUNTRY_DIMENSION)
    },
    toggleCountry (country, setDetailCountry = false, updateFilters = true) {
      let newValue = !country.selected
      country.selected = newValue
      this.$store.state.regions.filter(r => r.country === country.code).forEach(function (r) {
        r.selected = newValue
      }, this)
      if (setDetailCountry) {
        this.detailCountry = country
      }

      this.updateFiltersNow(updateFilters, this.constants.COUNTRY_DIMENSION)
    },
    toggleTopic (topic, newValue = false, setDetailTopic = false, updateFilters = true) {
      topic.selected = newValue

      this.subtopics.filter(r => r.parent === topic.code).forEach(function (t) {
        t.selected = newValue
      }, this)
      if (setDetailTopic) {
        this.detailTopic = topic
      }

      this.updateFiltersNow(updateFilters, this.constants.CLASS_DIMENSION)
    },
    toggleRootTopic (rootTopic) {
      let newValue = !this.someTopicsOfRootTopicSelected(rootTopic)
      rootTopic.selected = newValue

      for (let topic of this.topics.filter(t => t.parent === rootTopic.code)) {
        this.toggleTopic(topic, newValue, false, false)
      }

      this.updateFiltersNow(true, this.constants.CLASS_DIMENSION)
    },
    toggleAllRegions () {
      let newValue = !this.someRegionsSelected
      if (this.detailCountry === null) {
        this.$store.state.regions.forEach(function (r) {
          r.selected = newValue
        }, this)
        this.countries.forEach(function (c) {
          c.selected = newValue
        }, this)
      } else {
        this.$store.state.regions.filter(r => r.country === this.detailCountry.code).forEach(function (r) {
          r.selected = newValue
        }, this)
        this.detailCountry.selected = newValue
      }

      this.updateFiltersNow(true, this.constants.REGION_DIMENSION)
    },
    toggleRegion (region) {
      region.selected = !region.selected
      this.countries.find(c => c.code === region.country).selected = this.someRegionsSelected

      this.updateFiltersNow(true, this.constants.REGION_DIMENSION)
    },
    toggleSubtopic (subtopic, newValue = false, setDetailTopic = false, updateFilters = true) {
      subtopic.selected = newValue
      this.topics.find(c => c.code === subtopic.parent).selected = this.someSubtopicsSelected

      this.updateFiltersNow(updateFilters, this.constants.SUBCLASS_DIMENSION)
    },
    toggleAllSubtopics () {
      let newValue = !this.someSubtopicsSelected
      if (this.detailTopic === null) {
        this.subtopics.forEach(function (t) {
          t.selected = newValue
        }, this)
      } else {
        this.subtopics.filter(t => t.parent === this.detailTopic.code).forEach(function (t) {
          t.selected = newValue
        })
        this.detailTopic.selected = newValue
      }

      this.updateFiltersNow(true, this.constants.SUBCLASS_DIMENSION)
    },
    // TODO: toggleAllTopicsOfRootTopic(rootTopic)
    toggleAllTopics () {
      let newValue = !this.someTopicsSelected
      this.topics.forEach(function (t) {
        t.selected = newValue
      })
      this.subtopics.forEach(function (t) {
        t.selected = newValue
      })

      this.updateFiltersNow(true, this.constants.CLASS_DIMENSION)
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    updateSelectedComplement (elements) {
      if (elements.filter(t => t.selected).length === 1) {
        this.$store.dispatch('selectComplementItem', {'complementItem': elements.find(t => t.selected), 'loadData': false})
      } else if (elements.every(t => !t.selected) || elements.every(t => t.selected)) {
        this.$store.dispatch('selectComplementItem', {'complementItem': constants.AGGREGATE_COMPLEMENTS, 'loadData': false})
      } else {
        this.$store.dispatch('selectComplementItem', {'complementItem': constants.EACH_SELECTED_COMPLEMENT, 'loadData': false})
      }
    },
    updateFiltersNow (updateFilters, updateDimension) {
      if (updateFilters) {
        if (updateDimension.dimensionType === this.selectedComplement.dimensionType) {
          switch (this.selectedComplement) {
            case this.constants.COUNTRY_DIMENSION:
              this.updateSelectedComplement(this.countries)
              break
            case this.constants.REGION_DIMENSION:
              this.updateSelectedComplement(this.allRegions)
              break
            case this.constants.CLASS_DIMENSION:
              this.updateSelectedComplement(this.topics)
              break
            case this.constants.SUBCLASS_DIMENSION:
              this.updateSelectedComplement(this.subtopics)
              break
            default:
              break
          }
        }

        this.updateFilters = Date.now()
        this.$store.commit('setDataLoading', true)
      }
    },
    setFilterDimension (filterDimension) {
      // this.filterDimension = filterDimension
      this.$emit('update:filterDimension', filterDimension)
    },
    selectDetailCountry (country) {
      this.detailCountry = country
      if (this.isSelectedDimensionOrComplement(constants.COUNTRY_DIMENSION)) {
        country.tooltip = true
        this.sleep(6000).then(() => {
          country.tooltip = false
        }).then(() => {
          this.$forceUpdate()
        })
      }
    },
    openLocationFilter () {
      this.setFilterDimension('location')
      this.detailCountry = this.countries.find(c => c.selected)
    },
    closeLocationFilter () {
      this.setFilterDimension(null)
      this.detailCountry = this.countries.find(c => c.selected)
    },
    selectDetailTopic (topic) {
      this.detailTopic = topic
      if (this.isSelectedDimensionOrComplement(constants.CLASS_DIMENSION)) {
        topic.tooltip = true
        this.sleep(6000).then(() => {
          topic.tooltip = false
        }).then(() => {
          this.$forceUpdate()
        })
      }
    },
    selectSubtopic (subtopic) {
      let some = this.subtopics.some(t => t.parent === subtopic.parent && t.selected)
      this.topics.find(t => t.code === subtopic.parent).selected = some
    },
    openTopicFilter () {
      this.setFilterDimension('topic')
      this.detailTopic = this.topics.find(t => t.selected)
    },
    closeTopicFilter () {
      this.setFilterDimension(null)
      this.detailTopic = this.topics.find(t => t.selected)
    }
  }
}

</script>

<style scoped>
  .selectedFilterDimension {
    background-color: rgba(224, 224, 224, 0.9)
  }

  .flex {
    flex: 0 1 auto;
  }
  .navigation-drawer {
    padding-bottom: 20px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidedrawer.vue